/**
 * Utility function for dynamic city names based on URL parameters or embed config
 */
export const getCityName = (): string => {
  if (typeof window !== 'undefined') {
    // Check current window first
    let embedCity = (window as any).__VIEWPRO_CITY__;
    console.log('[getCityName] Checking current window:', embedCity);
    
    // If not found, check if there's an iframe and look in its window
    if (!embedCity) {
      const iframe = document.querySelector('iframe[srcdoc]') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        embedCity = (iframe.contentWindow as any).__VIEWPRO_CITY__;
        console.log('[getCityName] Checking iframe window:', embedCity);
      }
    }
    
    console.log('[getCityName] Final embed city:', embedCity);
    
    // Check URL parameters (for standalone mode)
    const urlParams = new URLSearchParams(window.location.search);
    const urlAubreyCity = urlParams.has('aubrey-tx') || urlParams.get('community') === 'aubrey-tx';
    const urlBaytownCity = urlParams.has('baytown-tx') || urlParams.get('community') === 'baytown-tx';
    console.log('[getCityName] URL city check - Aubrey:', urlAubreyCity, 'Baytown:', urlBaytownCity);
    
    // Use embed city first, then fall back to URL params
    const isAubreyTx = embedCity === 'aubrey-tx' || urlAubreyCity;
    const isBaytownTx = embedCity === 'baytown-tx' || urlBaytownCity;
    console.log('[getCityName] Is Aubrey TX:', isAubreyTx, 'Is Baytown TX:', isBaytownTx);
    
    if (isAubreyTx) {
      console.log('[getCityName] ✅ Returning: City of Aubrey');
      return 'City of Aubrey';
    }
    
    if (isBaytownTx) {
      console.log('[getCityName] ✅ Returning: City of Baytown');
      return 'City of Baytown';
    }
  }
  
  console.log('[getCityName] ❌ Returning: City of Mayorville (default)');
  return 'City of Mayorville';
};
